import React, {useEffect, useRef} from 'react'
import classes from './VideoCarouselItem.module.scss'
import { getFileName } from '../../../../../../helpers/FileCaching';

const introductionImages = require.context('../../../../../../images/components/Introduction', true, /.*\.(gif|png|jpe?g|svg)$/i);
const posterImages = require.context('../../../../../../images/components/Introduction/video_posters', true, /.*\.(gif|png|jpe?g|svg)$/i);

function VideoCarouselItem({content, isActive, onTimeoutComplete, shouldPreload, onPlayPress}){
	
	let carouselTimeoutLengthSeconds = 10
	let carouselTimeout = useRef(null)

	useEffect(() => {
		if(isActive){
			carouselTimeout.current = setTimeout(() => {
				onTimeoutComplete();
			}, 1000*carouselTimeoutLengthSeconds);
		}else{
			if(carouselTimeout.current != null){
				clearTimeout(carouselTimeout.current)
			}
		}
	}, [isActive])

	return (
		<section data-preload={`${shouldPreload}`} className={`${classes.VideoCarouselItem__wrapper} ${(isActive ? classes['VideoCarouselItem__wrapper--active'] : "")}`}>
			<div className={`${classes.VideoCarouselItem__contentContainer}`}>
				
				<div className={`${classes.VideoCarouselItem__video_background}`} style={
					{
						backgroundImage: `url(${getFileName(posterImages, content.posterImg)})`
					}
				}>
					<div  onClick={() => {onPlayPress()}} className={`${classes.VideoCarouselItem__playButton}`} 
						style={
							{
								backgroundImage: `url(${getFileName(introductionImages, 'playBtn.svg')})`
							}
						}
						>
					</div>
				</div>
				<p dangerouslySetInnerHTML={{__html:content.caption}}></p>
			
			</div>
        </section>
	)
}

export default VideoCarouselItem